<div
  *ngIf="tags?.length"
  class="item-tag-row"
  [class.item-tag-row-lg]="size === 'lg'"
  data-testid="item-tag-row"
>
  <span
    *ngFor="let tag of tags; trackBy: trackByTag"
    class="item-tag"
    [class.font-size-tertiary]="size !== 'lg'"
    [class.font-size-secondary]="size === 'lg'"
    data-testid="item-tag"
    [style.background-color]="tag.backgroundColour"
    [style.color]="tag.fontColour"
    [attr.title]="tag.label"
    >{{ tag.label }}</span
  >
</div>
